export const dashboardKeys = {
  overview: (locationId: string, demoStateOverride?: string | null) =>
    ['dashboard', 'overview', locationId, demoStateOverride ?? null] as const,
  actions: (locationId: string) => ['actions', locationId] as const,
};
